import styles from './previewForm.module.scss';

type Props = {
  title1: string;
  answers1: string[];
  title2?: string;
  answers2?: string[];
};

function PreviewForm(props: Props) {
  const { title1, answers1, title2, answers2 } = props;

  return (
    <div className={styles.wrapper}>
      <div className={styles.title}>Preview</div>
      <div className={styles.contentView}>
        <div className={styles.header}>
          <div className={styles.subTitle}>
            {title1}
          </div>
          <div className={styles.linecount}>
            {answers1.length} lines
          </div>
        </div>
        <ul style={{listStyleType: "disc"}}>
        {(answers1 ?? []).map((o, index) => {
          const optionStr: string = o as string;
          return (
            <li key={index} className={styles.questionBox}>
              {optionStr}
            </li>
          );
        })}
        </ul>
      </div>
      {title2 &&
      <div className={styles.contentView}>
        <div className={styles.header}>
          <div className={styles.subTitle}>
            {title2}
          </div>
          <div className={styles.linecount}>
            {answers2?.length} lines
          </div>
        </div>
        <ul style={{listStyleType: "disc"}}>
        {(answers2 ?? []).map((o, index) => {
          const optionStr: string = o as string;
          return (
            <li key={index} className={styles.questionBox}>
              {optionStr}
            </li>
          );
        })}
        </ul>
      </div>}
    </div>
  );
}

export default PreviewForm;